import Icon from '../components/Icon.vue'

Icon.register({
  snowplow: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M120 376C106.7 376 96 386.7 96 400S106.7 424 120 424 144 413.3 144 400 133.3 376 120 376zM200 376C186.7 376 176 386.7 176 400S186.7 424 200 424 224 413.3 224 400 213.3 376 200 376zM280 376C266.7 376 256 386.7 256 400S266.7 424 280 424 304 413.3 304 400 293.3 376 280 376zM360 376C346.7 376 336 386.7 336 400S346.7 424 360 424 384 413.3 384 400 373.3 376 360 376zM598.6 425.4C584.1 410.9 576 391.3 576 370.8V269.2C576 248.7 584.1 229.1 598.6 214.6L635.3 177.9C641.5 171.7 641.5 161.5 635.3 155.3L612.7 132.7C606.5 126.5 596.3 126.5 590.1 132.7L553.4 169.4C526.9 195.9 512 231.8 512 269.3V288H448V237.1C448 228.4 446.2 219.9 442.8 211.9L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176C149.5 0 128 21.5 128 48V160H112C85.5 160 64 181.5 64 208V299.2C26.3 317.2 0 355.4 0 400 0 461.9 50.1 512 112 512H368C429.9 512 480 461.9 480 400 480 382.7 475.8 366.6 468.8 352H512V370.7C512 408.2 526.9 444.1 553.4 470.6L590.1 507.3C596.3 513.5 606.5 513.5 612.7 507.3L635.3 484.7C641.5 478.5 641.5 468.3 635.3 462.1L598.6 425.4zM192 64H309.8L378.4 224H256L192 160V64zM368 448H112C85.5 448 64 426.5 64 400S85.5 352 112 352H368C394.5 352 416 373.5 416 400S394.5 448 368 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/snowplow.js
// module id = rmg/
// module chunks = 144